import { OtpCodeInputGroup } from './view';
export { useOtpCodeSchema } from './hook';

export default OtpCodeInputGroup;
